import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

interface PublicOnlyRouteProps {
  children: ReactElement;
}

/** Renders `children` only when signed out (e.g. login); authenticated users are sent to their profile. */
export const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({
  children,
}) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/profile" replace /> : children;
};
